var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Monitor_setting",
    "data-name": "Monitor setting"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,15a3,3,0,0,0-3-3H51.144l.343.343a1,1,0,0,1,0,1.414L51.244,14H57a1,1,0,0,1,1,1V45a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h5V12H7a3,3,0,0,0-3,3V47a3,3,0,0,0,3,3H57a3,3,0,0,0,3-3ZM33,49H31a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 12,
    r: 2,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13h2.35a1,1,0,0,1,.958.713,2.239,2.239,0,0,0,.167.4,1,1,0,0,1-.178,1.173L15.634,16.95l1.416,1.416L18.713,16.7a1,1,0,0,1,1.171-.179,2.262,2.262,0,0,0,.4.168A1,1,0,0,1,21,17.65V20h2V17.65a1,1,0,0,1,.713-.958,2.262,2.262,0,0,0,.4-.168,1,1,0,0,1,1.171.179l1.663,1.663,1.416-1.416L26.7,15.287a1,1,0,0,1-.179-1.171,2.262,2.262,0,0,0,.168-.4A1,1,0,0,1,27.65,13H30V11H27.65a1,1,0,0,1-.958-.713,2.262,2.262,0,0,0-.168-.4A1,1,0,0,1,26.7,8.713L28.366,7.05,26.95,5.634,25.287,7.3a1,1,0,0,1-1.171.179,2.262,2.262,0,0,0-.4-.168A1,1,0,0,1,23,6.35V4H21V6.35a1,1,0,0,1-.713.958,2.262,2.262,0,0,0-.4.168A1,1,0,0,1,18.713,7.3L17.05,5.634,15.634,7.05,17.3,8.713a1,1,0,0,1,.178,1.173,2.239,2.239,0,0,0-.167.4A1,1,0,0,1,16.35,11H14Zm8-5a4,4,0,1,1-4,4A4,4,0,0,1,22,8Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 52,
    width: 10,
    height: 4,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,60H46a1,1,0,0,0,0-2H18a1,1,0,0,0,0,2Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,42a3.943,3.943,0,0,0,.544,2h6.912A3.943,3.943,0,0,0,34,42a4,4,0,0,0-8,0Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.692,19.713A1,1,0,0,1,48.65,19H51V17H48.65a1,1,0,0,1-.958-.713,2.262,2.262,0,0,0-.168-.4,1,1,0,0,1,.179-1.171l1.663-1.663L47.95,11.634,46.287,13.3a1,1,0,0,1-1.171.179,2.262,2.262,0,0,0-.4-.168A1,1,0,0,1,44,12.35V10H42v2.35a1,1,0,0,1-.713.958,2.262,2.262,0,0,0-.4.168,1,1,0,0,1-1.171-.179L38.05,11.634,36.634,13.05,38.3,14.713a1,1,0,0,1,.178,1.173,2.239,2.239,0,0,0-.167.4A1,1,0,0,1,37.35,17H35v2h2.35a1,1,0,0,1,.958.713,2.239,2.239,0,0,0,.167.4,1,1,0,0,1-.178,1.173L36.634,22.95l1.416,1.416L39.713,22.7a1,1,0,0,1,1.171-.179,2.262,2.262,0,0,0,.4.168A1,1,0,0,1,42,23.65V26h2V23.65a1,1,0,0,1,.713-.958,2.262,2.262,0,0,0,.4-.168,1,1,0,0,1,1.171.179l1.663,1.663,1.416-1.416L47.7,21.287a1,1,0,0,1-.179-1.171A2.262,2.262,0,0,0,47.692,19.713ZM43,22a4,4,0,1,1,4-4A4,4,0,0,1,43,22Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 18,
    r: 2,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.855,11H32v3a1,1,0,0,1-1,1H29.244l1.243,1.243a1,1,0,0,1,0,1.414l-2.83,2.83a1,1,0,0,1-1.414,0L25,19.244V21a1,1,0,0,1-1,1H20a1,1,0,0,1-1-1V19.244l-1.243,1.243a1,1,0,0,1-1.414,0l-2.83-2.83a1,1,0,0,1,0-1.414L13.756,16H8V44h7V39a1,1,0,0,1,1-1h3.753c.057-.144.114-.283.174-.419l-2.654-2.654a1,1,0,0,1,0-1.414l4.24-4.24a1,1,0,0,1,1.414,0l2.654,2.654c.136-.06.275-.117.419-.174V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v3.753c.144.057.283.114.419.174l2.654-2.654a1.029,1.029,0,0,1,1.414,0l4.24,4.24a1,1,0,0,1,0,1.414l-2.654,2.654c.06.136.117.275.174.419H44a1,1,0,0,1,1,1v5H56V16H53v4a1,1,0,0,1-1,1H50.244l1.243,1.243a1,1,0,0,1,0,1.414l-2.83,2.83a1,1,0,0,1-1.414,0L46,25.244V27a1,1,0,0,1-1,1H41a1,1,0,0,1-1-1V25.244l-1.243,1.243a1,1,0,0,1-1.414,0l-2.83-2.83a1,1,0,0,1,0-1.414L35.756,21H34a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h1.756l-1.243-1.243a1,1,0,0,1,0-1.414Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.412,39.306A1,1,0,0,1,20.46,40H17v4h7.346a6,6,0,1,1,11.308,0H43V40H39.54a1,1,0,0,1-.952-.694,8.259,8.259,0,0,0-.605-1.445,1,1,0,0,1,.17-1.188l2.453-2.453L37.78,31.394l-2.453,2.453a1,1,0,0,1-1.188.17,8.259,8.259,0,0,0-1.445-.605A1,1,0,0,1,32,32.46V29H28v3.46a1,1,0,0,1-.694.952,8.259,8.259,0,0,0-1.445.605,1,1,0,0,1-1.188-.17L22.22,31.394,19.394,34.22l2.453,2.453a1,1,0,0,1,.17,1.188A8.259,8.259,0,0,0,21.412,39.306Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorities);
export default __webpack_public_path__ + "static/media/priorities.6af64b55.svg";
export { ForwardRef as ReactComponent };